import styled from "styled-components";
import DeviceTiles from "../components/home/DashboardComponents/DeviceTiles";
import Graph from "../components/home/DashboardComponents/Graph";
import Notifications from "../components/home/DashboardComponents/Notifications";
import { useEffect, useState } from "react";
import { getDeviceDashboard } from "../api/getDevicesDashboard";



function Dashboard() {
  const user = JSON.parse(localStorage.getItem("user"));
  const [devicesData, setDevicesData] = useState({});
  const [graphData, setGraphData] = useState({
    graphData: {
      daily: {
        data: [],
        labels: []
      },
      daily_reported: [],
      total: 0
    }
  })


  useEffect(() => {
    try {
      init(user.token, user.id, setGraphData, setDevicesData)
    } catch (e) {
      console.log('Error: ', e)
    }

  }, [user?.token, user?.id])
  return (
    <Container>
      <DeviceTiles devices={devicesData} />
      <Graph graphData={graphData.daily}/>
      <Notifications devices={devicesData} />
    </Container>
  )
}


async function init(token, id, setGraph, setDevices) {
  try {
    const response = await getDeviceDashboard(id, token);
    if (response.error) {
      console.log('Error: ', response.message || response.status_code || "Unknown error");
      if (response.status_code === 401) {
        localStorage.removeItem("user");
        window.location.href = "/login";
      }
      return;
    }
    const data = response.data;
    //Calcular consumo
    const consumptionData = [];
    const consumptionLabels = [];

    for (let i = 0; i < 24; i++) {
      consumptionData.push((data.consumption[i] / 1000) || 0);
      consumptionLabels.push(i.toString().padStart(2, "0"));
    }
    /* *********************************** */
    //Obtener estado de dispositivos
    let connected = 0;
    let disconnected = 0;
    let warning = 0;
    let critical = 0;
    for (const device of data.data) {
      //console.log(device)
      switch (device.status) {
        case 0:
          disconnected++;
          warning++;
          critical++;
          break;
        case 1:
          warning++;
          break;
        case 2:
          connected++;
          break;
        default:
          break;
      }
    }

    //Setear valores
    setDevices({
      connected,
      disconnected,
      warning,
      critical
    })
    const dailyConsumption = parseConsumption(data.consumption.hours);
    console.log('Daily consumption: ', dailyConsumption)
    setGraph({
      daily: dailyConsumption,
      total: data.consumption.total
    })


  } catch (e) {
    console.log('Error: ', e)
  }
}


function parseConsumption(obj) {
  const data = [];
  const labels = [];

  Object.keys(obj)
    .sort((a, b) => Number(a) - Number(b))
    .forEach(key => {
      data.push((obj[key]) / 1000 || 0);
      labels.push(key.toString().padStart(2, "0"));
    });

  return { data, labels };
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  width: 100%;
`

export default Dashboard